module.exports = __webpack_public_path__ + "img/yilianGl4.38092039.png";